import { Text, Box, Heading } from 'braid-design-system';
import React from 'react';

import ImageCard from '../ImageCard/ImageCard';

import * as styles from './style.css';

interface ArticleCardProps {
  title: string;
  url: string;
  imageUrl: string;
  htag: string;
  secondaryTitle: string;
}

const ArticleCard = (props: ArticleCardProps) => (
  <ImageCard {...props}>
    <Heading level="4">{props.title}</Heading>
    <Box className={styles.secondaryTitle}>
      <Text tone="secondary">{props.secondaryTitle}</Text>
    </Box>
  </ImageCard>
);
export default ArticleCard;
